
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veterans/hwajang/[companyname]",
      function () {
        return require("private-next-pages/veterans/hwajang/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veterans/hwajang/[companyname]"])
      });
    }
  